export default "__VITE_ASSET__GeiOR1eA__"